var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "span",
                { staticStyle: { "font-weight": "bold", "font-size": "16px" } },
                [_vm._v("Beta Groups")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right" },
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleCreateGroup },
                },
                [_vm._v(" Create Group ")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.groupsLoading,
                  expression: "groupsLoading",
                },
              ],
              attrs: {
                data: _vm.groups,
                border: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "ID", prop: "id", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { label: "Group Key", prop: "groupKey", width: "150" },
              }),
              _c("el-table-column", {
                attrs: { label: "Group Name", prop: "groupName", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { label: "Description", prop: "description" },
              }),
              _c("el-table-column", {
                attrs: { label: "Default", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.isDefault ? "success" : "info",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(row.isDefault ? "Yes" : "No") + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Active", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: row.isActive ? "success" : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(row.isActive ? "Yes" : "No") + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Actions", width: "280", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewMembers(row)
                              },
                            },
                          },
                          [_vm._v(" Members ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "info", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleViewOtaVersions(row)
                              },
                            },
                          },
                          [_vm._v(" OTA Files ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "warning", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditGroup(row)
                              },
                            },
                          },
                          [_vm._v(" Edit ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              disabled: row.isDefault,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDeleteGroup(row)
                              },
                            },
                          },
                          [_vm._v(" Delete ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.selectedGroup
        ? _c(
            "el-card",
            {
              staticClass: "box-card",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [
                      _vm._v(
                        ' Members of "' +
                          _vm._s(_vm.selectedGroup.groupName) +
                          '" '
                      ),
                      _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { size: "small" },
                        },
                        [_vm._v(_vm._s(_vm.members.length) + " members")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right" },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.openAddMemberDialog },
                    },
                    [_vm._v(" Add User ")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", "margin-right": "10px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.selectedGroup = null
                        },
                      },
                    },
                    [_vm._v(" Close ")]
                  ),
                ],
                1
              ),
              _vm.memberSummary
                ? _c("div", { staticClass: "member-summary" }, [
                    _c(
                      "span",
                      [
                        _vm._v(" Target build: "),
                        _vm.memberSummary.targets.length
                          ? _vm._l(_vm.memberSummary.targets, function (t) {
                              return _c(
                                "el-tag",
                                {
                                  key: t.applicationVersionName,
                                  staticStyle: { "margin-right": "6px" },
                                  attrs: { size: "mini", type: "success" },
                                },
                                [
                                  _vm._v(
                                    " V" +
                                      _vm._s(t.majorVersion) +
                                      ": " +
                                      _vm._s(t.applicationVersionName) +
                                      " / " +
                                      _vm._s(t.wirelessVersionName) +
                                      " "
                                  ),
                                ]
                              )
                            })
                          : _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v("No build assigned to this group")]
                            ),
                      ],
                      2
                    ),
                    _c("span", { staticStyle: { "margin-left": "18px" } }, [
                      _vm._v(" Installed: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.memberSummary.onTargetMembers)),
                      ]),
                      _vm._v(
                        " / " +
                          _vm._s(_vm.memberSummary.reportingMembers) +
                          " reporting "
                      ),
                      _c("span", { staticClass: "muted" }, [
                        _vm._v(
                          "(" +
                            _vm._s(_vm.memberSummary.totalMembers) +
                            " members total)"
                        ),
                      ]),
                    ]),
                    _vm.memberSummary.totalMembers >
                    _vm.memberSummary.reportingMembers
                      ? _c("span", { staticClass: "muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.memberSummary.totalMembers -
                                  _vm.memberSummary.reportingMembers
                              ) +
                              " member(s) have not reported firmware yet, their status cannot be determined. "
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "member-filter-row" },
                [
                  _c("el-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      placeholder:
                        "Filter by email, name, user ID or cane serial",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.memberFilter,
                      callback: function ($$v) {
                        _vm.memberFilter = $$v
                      },
                      expression: "memberFilter",
                    },
                  }),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px", "margin-left": "10px" },
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "Any OTA status",
                      },
                      model: {
                        value: _vm.memberStatusFilter,
                        callback: function ($$v) {
                          _vm.memberStatusFilter = $$v
                        },
                        expression: "memberStatusFilter",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "installed", value: "installed" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "not installed",
                          value: "not installed",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "unknown", value: "unknown" },
                      }),
                      _c("el-option", {
                        attrs: { label: "no cane", value: "no cane" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { size: "small" },
                      on: { click: _vm.handleSelectAllFiltered },
                    },
                    [
                      _vm._v(
                        " Select all filtered (" +
                          _vm._s(_vm.filteredMembers.length) +
                          ") "
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "danger",
                        disabled: !_vm.selectedMembers.length,
                      },
                      on: { click: _vm.handleBulkRemove },
                    },
                    [
                      _vm._v(
                        " Remove selected (" +
                          _vm._s(_vm.selectedMembers.length) +
                          ") "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.membersLoading,
                      expression: "membersLoading",
                    },
                  ],
                  ref: "membersTable",
                  attrs: {
                    data: _vm.filteredMembers,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    "empty-text": "No members match",
                  },
                  on: { "selection-change": _vm.handleMemberSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "45" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Name", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.user
                                      ? (
                                          (row.user.firstName || "") +
                                          " " +
                                          (row.user.lastName || "")
                                        ).trim() || "-"
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2593634743
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Email", width: "230" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.user && row.user.email
                                      ? row.user.email
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      368127078
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "OTA Status", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.memberStatusTag(row),
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.memberStatusLabel(row)) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3280817494
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Cane / Firmware", "min-width": "260" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              !row.devices || !row.devices.length
                                ? _c("span", { staticClass: "muted" }, [
                                    _vm._v("No cane registered"),
                                  ])
                                : _vm._e(),
                              _vm._l(row.devices, function (d) {
                                return _c(
                                  "div",
                                  {
                                    key: d.serialNumber,
                                    staticClass: "device-line",
                                  },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: _vm.deviceStatusTag(d.status),
                                          size: "mini",
                                        },
                                      },
                                      [_vm._v(_vm._s(d.status))]
                                    ),
                                    _c("span", { staticClass: "serial" }, [
                                      _vm._v(_vm._s(d.serialNumber)),
                                    ]),
                                    d.installedAppVersion
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(d.installedAppVersion) +
                                              " / " +
                                              _vm._s(
                                                d.installedWirelessVersion ||
                                                  "-"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("span", { staticClass: "muted" }, [
                                          _vm._v("no firmware reported"),
                                        ]),
                                    d.status === "outdated" &&
                                    d.targetAppVersion
                                      ? _c("span", { staticClass: "muted" }, [
                                          _vm._v(
                                            " (target " +
                                              _vm._s(d.targetAppVersion) +
                                              " / " +
                                              _vm._s(d.targetWirelessVersion) +
                                              ") "
                                          ),
                                        ])
                                      : _vm._e(),
                                    d.installedReportedAt
                                      ? _c("span", { staticClass: "muted" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatDate(
                                                  d.installedReportedAt
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3840599980
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Last Served", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              row.lastServed
                                ? [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.lastServed
                                            .applicationVersionName || "-"
                                        ) +
                                        " "
                                    ),
                                    _c("div", { staticClass: "muted" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            row.lastServed.servedAt
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                : _c("span", { staticClass: "muted" }, [
                                    _vm._v("never"),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1711322850
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "User ID", prop: "userId" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Assigned By",
                      prop: "assignedBy",
                      width: "200",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Assigned At", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDate(row.assignedAt)) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      190744252
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Actions", width: "100", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRemoveMember(row)
                                    },
                                  },
                                },
                                [_vm._v(" Remove ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2241964319
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.selectedOtaGroup
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "16px",
                      },
                    },
                    [
                      _vm._v(
                        ' OTA Versions for "' +
                          _vm._s(_vm.selectedOtaGroup.groupName) +
                          '" '
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", "margin-right": "10px" },
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          _vm.selectedOtaGroup = null
                        },
                      },
                    },
                    [_vm._v(" Close ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.otaLoading,
                      expression: "otaLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.otaVersions,
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    "empty-text": "No OTA versions assigned to this group",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "ID", prop: "id", width: "60" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Wireless Version", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                { attrs: { type: "primary", size: "small" } },
                                [_vm._v(_vm._s(row.wirelessVersionName || "-"))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      884484058
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "App Version", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                { attrs: { type: "success", size: "small" } },
                                [
                                  _vm._v(
                                    _vm._s(row.applicationVersionName || "-")
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3526661487
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Active", width: "80", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: row.isActive ? "success" : "danger",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.isActive ? "Yes" : "No") +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      643127572
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Mandatory",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: row.isMandatory ? "danger" : "info",
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(row.isMandatory ? "Yes" : "No") +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3394430393
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Rollout %",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " + _vm._s(row.rolloutPercentage) + "% "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1690896401
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Released At", width: "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ row }) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    row.releasedAt
                                      ? _vm.formatDate(row.releasedAt)
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2170368965
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Description", prop: "description" },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogGroupStatus === "create"
                ? "Create Beta Group"
                : "Edit Beta Group",
            visible: _vm.dialogGroupVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogGroupVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "groupForm",
              attrs: {
                model: _vm.groupForm,
                rules: _vm.groupRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Group Key", prop: "groupKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., early-access",
                      disabled: _vm.dialogGroupStatus === "edit",
                    },
                    model: {
                      value: _vm.groupForm.groupKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupForm, "groupKey", $$v)
                      },
                      expression: "groupForm.groupKey",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Group Name", prop: "groupName" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "e.g., Early Access" },
                    model: {
                      value: _vm.groupForm.groupName,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupForm, "groupName", $$v)
                      },
                      expression: "groupForm.groupName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      placeholder: "Description of this group",
                      rows: 3,
                    },
                    model: {
                      value: _vm.groupForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupForm, "description", $$v)
                      },
                      expression: "groupForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Default" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.groupForm.isDefault,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupForm, "isDefault", $$v)
                      },
                      expression: "groupForm.isDefault",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "margin-left": "8px",
                        color: "#909399",
                        "font-size": "12px",
                      },
                    },
                    [_vm._v(" New users will be assigned to this group ")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Active" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.groupForm.isActive,
                      callback: function ($$v) {
                        _vm.$set(_vm.groupForm, "isActive", $$v)
                      },
                      expression: "groupForm.isActive",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogGroupVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitGroup },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.dialogGroupStatus === "create" ? "Create" : "Update"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Add Users to Group",
            visible: _vm.dialogAddMemberVisible,
            width: "560px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAddMemberVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "memberForm",
              attrs: { model: _vm.memberForm, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Users", prop: "userIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        multiple: "",
                        filterable: "",
                        remote: "",
                        clearable: "",
                        "reserve-keyword": "",
                        placeholder: "Search by email or name",
                        "remote-method": _vm.remoteSearchUsers,
                        loading: _vm.userSearchLoading,
                      },
                      model: {
                        value: _vm.memberForm.userIds,
                        callback: function ($$v) {
                          _vm.$set(_vm.memberForm, "userIds", $$v)
                        },
                        expression: "memberForm.userIds",
                      },
                    },
                    _vm._l(_vm.userOptions, function (u) {
                      return _c("el-option", {
                        key: u.userId,
                        attrs: { label: u.label, value: u.userId },
                      })
                    }),
                    1
                  ),
                  _c(
                    "span",
                    { staticStyle: { color: "#909399", "font-size": "12px" } },
                    [
                      _vm._v(
                        " Type at least 2 characters to search. You can pick several users before saving. A user already in another group will be moved to this one. "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogAddMemberVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.submitAddMember },
                },
                [_vm._v("Add")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }